import styled from 'styled-components';

export const FeatureList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const IncludedTitle = styled.p`
  margin: 0;
`;
